import { LoadingOverlay } from '@mantine/core';
import type { Dispatch, SetStateAction } from 'react';
import { useParams } from 'react-router-dom';
import { SmallModal } from '../../../components/SmallModal';
import { useModal } from '../../../hooks/useModal';
import { mutate } from '../../../util/api/mutate';
import type { BankingDto } from '../types/BankingDto';

interface ModerateModalProps {
	close: () => void;
	isOpened: boolean;
	displayDate: string;
	bankingId: string;
	updateTableRow: Dispatch<SetStateAction<BankingDto>>;
}

export function ProcessModal({
	close,
	isOpened,
	displayDate,
	bankingId,
	updateTableRow,
}: ModerateModalProps) {
	const { organisation } = useParams();

	const completeModal = useModal();

	const moderateMutation = mutate<BankingDto>(
		`${organisation}/banking/process/${bankingId}`,
	);

	return (
		<>
			<LoadingOverlay
				bg={'#000'}
				opacity={0.85}
				visible={moderateMutation.isLoading}
			/>
			<SmallModal
				isOpen={isOpened}
				close={close}
				title={'Process Record'}
				body={
					<>
						Are you sure you want to process record of date <i>{displayDate}</i>
						? Click OK to confirm...
					</>
				}
				onComplete={async () => {
					close();

					await moderateMutation
						.mutateAsync()
						.then((data) => updateTableRow(data.value))
						.then(() => completeModal.open());
				}}
			/>
			<SmallModal
				isOpen={completeModal.isOpen}
				close={completeModal.close}
				title={'Process Complete'}
				body={
					<>
						Process of <i>{displayDate}</i> has successfully completed. Click OK
						to continue...
					</>
				}
			/>
		</>
	);
}
